// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const nickit: PokeData = {
  "id": 827,
  "name": "nickit",
  "height": 6,
  "weight": 89,
  "base_experience": 49,
  "types": [
    PokeType.DARK
  ],
  "api_moves": [
    "tail-whip",
    "quick-attack",
    "beat-up",
    "assurance",
    "sucker-punch",
    "night-slash",
    "nasty-plot",
    "hone-claws",
    "foul-play",
    "tail-slap",
    "snarl"
  ],
  "moves": [
    "quick-attack",
    "night-slash",
    "snarl",
    "night-daze",
    "dark-pulse",
    "pursuit",
    "crunch",
    "snatch",
    "dark-bargain",
    "lash-out",
    "flatter",
    "bite",
    "phantom-force"
  ],
  "evolution_chain": {
    "id": 436,
    "item": null,
    "species": [
      {
        "name": "nickit",
        "order": 827,
        "types": [
          PokeType.DARK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "thievul",
        "order": 828,
        "types": [
          PokeType.DARK
        ],
        "evolves_from_species_id": 827,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 18,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 40,
    "speed": 50,
    "ability_power": 47
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
